import React, { Dispatch } from 'react';
import { useDispatch } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../../store/ducks/entregaNoCd/actions';
import { Card, List } from 'antd';
import { RowLine, SpanBlock } from './styles';
import { maskCurrency, maskUnd } from '../../../../../../utils/mask';
import CardSecMobile from '../CardSecMobile';
// import ModalCriarAgendamento from '../../../../components/ModalCriarAgendamento';

const CardMobile: React.FC<any> = ({
  props,
  loading,
  inscricaoAtiva,
  cddAtivo,
  filter,
  pagination,
}) => {
  const dispatch = useDispatch<Dispatch<Action>>();

  const paginationProps = {
    onChange: (pag: any) => {
      const resultado = {
        ...pagination,
        current: pag,
      };
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codEmp,
          resultado
        )
      );
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };

  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      pagination={paginationProps}
      loading={loading}
      dataSource={props}
      renderItem={(item: any) => (
        <List.Item>
          <Card title={props.nuNota}>
            {/* <ModalCriarAgendamento /> */}

            <RowLine>
              <p>
                <strong>Ordem entrega</strong> <SpanBlock>{item.ordemEntrega}</SpanBlock>
              </p>
              <p>
                <strong>Transportadora</strong> <SpanBlock>{item.nomeTransportadora}</SpanBlock>
              </p>
              <p>
                <strong>Tipo veículo</strong> <SpanBlock>{item.tipoVeiculo}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Placa</strong> <SpanBlock>{item.placa}</SpanBlock>
              </p>
              <p>
                <strong>Nome do motorista</strong> <SpanBlock>{item.nomeMotorista}</SpanBlock>
              </p>
              <p>
                <strong>CPF</strong> <SpanBlock>{item.cpfMotorista}</SpanBlock>
              </p>
            </RowLine>
            <RowLine>
              <p>
                <strong>Peso</strong> <SpanBlock>{maskUnd(item.peso) + ' KG'}</SpanBlock>
              </p>
              <p>
                <strong>Valor</strong> <SpanBlock>{maskCurrency(item.valor)}</SpanBlock>
              </p>
            </RowLine>

            <CardSecMobile ordemEntrega={item.ordemEntrega} cddAtivo={cddAtivo.codEmp} />
          </Card>
        </List.Item>
      )}
    />
  );
};
export default CardMobile;
